
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import StateButton from '@/components/inputs/StateButton.vue';

import userx from '@/store/modules/userx';
import programx from '@/store/modules/programx';
import programz from '@/store/programz';
import progressToastx from '@/store/modules/progressToastx';

import { ProgramData, Program, permissionsGroups } from '@/store/models.def';
import ProgramQuery from './ProgramQuery.vue';
import uuid from 'uuid';

@Component({
	components: {
		ProgramQuery,
	},
})
export default class ProgramGroup extends Vue {
	public get queries() {
		return this.data.queries.map((query) => ({
			query,
		}));
	}

	public get supportLvl() {
		return userx.user && userx.user.supportLvl;
	}
	public get options() {
		return ['', ...permissionsGroups];
	}
	@Prop({ default: null }) public value!: Program | null;

	public data: Program = { queries: [] };

	@Watch('value')
	public onValueChanged(val: Program, oldVal: Program) {
		if (val !== null) {
			this.data = val;

			const result = this._validfy();
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}
	public mounted() {
		let result = null;
		if (this.value) {
			this.data = this.value;
			result = this._validfy();
		}
		if (result === null) {
			this.$emit('input', null);
		}
	}
	public addQuery() {
		this.data!.queries = [
			...this.data!.queries,
			{
				query: '',
				file: '',
			},
		];
		this._onInput();
	}
	public removeQuery(index: number) {
		this.data!.queries.splice(index, 1);
		this._onInput();
	}
	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		for (const query of this.queries) {
			console.log(query.query);
			if (!query.query) {
				return null;
			}
		}
		return this.data;
	}
}
